export default "__VITE_ASSET__CIwjQy$g__"